<template>
  <section
    class="relative h-full w-full overflow-hidden"
  >
    <div
      id="pano"
      class="h-full"
    />

    <!-- <webVrGyroBtns
      class="absolute top-3 right-3 z-20"
      @toggleGyro="toggleGyro"
      @enterVr="enterVr"
    /> -->

    <!-- Ctrl + shift + alt + u to get start positions -->
    <div
      v-if="showStartPosition"
      class="absolute top-20 left-20 p-4 bg-white"
    >
      <p>h: {{ Math.round(startPosition.h) }}</p>
      <p>v: {{ Math.round(startPosition.v) }}</p>
      <button
        @click="getStartPosition"
        class="mt-3 flex-c bg-black px-5 py-2 text-white hover:text-primary"
      >
        Get start position
      </button>
    </div>

    <ChevronBtn
      v-show="pager.tourGroupLength > 1"
      :direction="'next'"
      :title="'Next 360'"
      class="fixed right-3 pin-c-y"
      @click.native="handleNavigation('next')"
    />

    <ChevronBtn
      v-show="pager.tourGroupLength > 1"
      :direction="'prev'"
      :title="'Previous 360'"
      class="fixed left-3 pin-c-y"
      @click.native="handleNavigation('prev')"
    />

    <FpNavDotsSlide
      v-show="pager.tourGroupLength > 1"
      :slides="tourGroup"
      class="absolute top-6 md:top-8 lg:top-auto lg:bottom-12 pin-c-x"
    />

    <div
      class="panorama-info absolute bottom-0 right-0 w-screen md:w-96 px-6 pb-6 text-black bg-primary transition"
      :class="{ 'info-hidden': !infoVisible }"
      @click="infoVisible = !infoVisible"
    >
      <button
        class="absolute top-6 right-6 focus-a"
        :title="infoVisible ? 'Close information' : 'Open information'"
        :class="{ 'rotate-180': !infoVisible}"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="32" viewBox="0 0 59 32" v-bind:svg-inline="''" v-bind:class="'h-3 w-6'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M58.468 1.393l-.936-.928c-.287-.288-.684-.466-1.123-.466s-.836.178-1.123.466L29.473 26.289 3.649.465c-.288-.291-.686-.47-1.127-.47s-.84.18-1.127.47l-.928.928c-.288.287-.466.684-.466 1.123s.178.836.466 1.123l27.87 27.886c.287.288.684.466 1.123.466s.836-.178 1.123-.466l27.87-27.886a1.57 1.57 0 00.016-2.246z"/></svg>
      </button>
      <h1
        class="text-xl py-6"
        v-html="post.title"
      />

      <p
        class="mb-6 font-graphiklight"
        v-html="post.description"
      />

      <a
        :href="utmhref(post.linkout, 'tier-2-cta')"
        target="_blank"
        class="inline-block px-6 py-4 btn--black focus-a"
      >
        {{ post.cta }}

        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" v-bind:svg-inline="''" v-bind:class="'inline-block h-4 w-4 -mt-1 ml-1 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M36 1.5v7.999a1.501 1.501 0 01-2.561 1.06l-2.232-2.232-15.221 15.22c-.271.271-.646.439-1.061.439s-.789-.168-1.061-.439l-1.414-1.414c-.271-.271-.439-.646-.439-1.061s.168-.789.439-1.061L27.671 4.792 25.44 2.56a1.5 1.5 0 011.059-2.561h8c.828 0 1.499.671 1.499 1.499v.001zM25.439 16.925l-1.003 1.003a1.5 1.5 0 00-.438 1.055v9.018H4V8h16.502c.413 0 .788-.167 1.059-.438l1.003-1.003a1.5 1.5 0 00-1.06-2.56H3a3 3 0 00-3 3V29a3 3 0 003 3h22.002a3 3 0 003-3V17.985v-.001a1.5 1.5 0 00-2.563-1.059z"/></svg>
      </a>

    </div>
  </section>
</template>

<script>
/* eslint-disable camelcase */
/* global removepano: false, embedpano: false */
// import webVrGyroBtns from '@/components/buttons/webVrGyroBtns.vue'
import { mapState, mapGetters } from 'vuex'
import ChevronBtn from '@/components/buttons/ChevronBtn.vue'
import FpNavDotsSlide from '@/components/FpNavDotsSlide.vue'

export default {
  name: 'Panorama',

  components: {
    // WebVrGyroBtns,
    ChevronBtn,
    FpNavDotsSlide
  },

  props: {
    tourGroup: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    post() {
      this.krpTour()
    },
    $route: {
      immediate: true,
      handler() {
        this.$announcer.set(`${this.post.title}, ${this.post.audioDescription}`)
      }
    }
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      pano: '',
      infoVisible: true,
      showStartPosition: false,
      startPosition: {
        v: 0,
        h: 0
      }
    }
  },

  computed: {
    ...mapGetters([ 'post' ]),

    pager() {
      const tourGroup = this.tourGroup

      const tourGroupLength = tourGroup.length

      const tourGroupSlugs = tourGroup.map(({ slug }) => slug)

      const currentPanorama = this.$route.params.panorama_id

      const currentIndex = tourGroupSlugs.indexOf(currentPanorama)

      const prev = currentIndex > 0 ? tourGroup[currentIndex - 1] : tourGroup[tourGroupLength - 1]

      const next = currentIndex < tourGroupLength - 1 ? tourGroup[currentIndex + 1] : tourGroup[0]

      return { prev, next, currentIndex, currentPanorama, tourGroup, tourGroupLength }
    }
  },

  mounted() {
    embedpano({
      xml: 'vendor/krpano.xml',
      target: 'pano',
      id: 'rama',
      mobilescale: 1.0,
      wmode: 'transparent',
      onready: this.krpReady
    })

    document.onkeyup = (e) => {
      if (e.ctrlKey && e.altKey && e.shiftKey && e.which === 85) {
        this.showStartPosition = !this.showStartPosition
      }
    }
  },

  beforeDestroy() {
    removepano('rama')
    this.pano = false
  },

  methods: {
    krpReady(rama) {
      this.pano = rama
      this.pano.setAttribute('tabindex', 0)
      window.activekrpanowindow = 'rama'
      // Window.onSpotClick = this.onSpotClick
      // window.onNavSpotClick = this.onNavSpotClick
      window.rvonentervr = this.rvonentervr
      window.rvonexitvr = this.rvonexitvr
      window.rvvrnext = this.rvvrnext
      window.rvvrprevious = this.rvvrprevious

      this.krpTour()
    },
    krpTour() {
      // For the odd one out with a pan limit
      const pan = this.post.hlookatmax
        ? {
          hmax: this.post.hlookatmax,
          hmin: this.post.hlookatmin
        }
        : {
          hmax: 360,
          hmin: 0
        }

      const krpScene = `
        <krpano>
          <view
            fov="80.0"
            fovmax="105"
            fovmin="65"
            hlookat="${this.post.h}"
            vlookat="${this.post.v}"
            hlookatmin="${pan.hmin}"
            hlookatmax="${pan.hmax}"
            vlookatmin="${-90}"
            vlookatmax="${90}"
            limitview="lookat"
            fisheye="0" />
          <preview url="uploads/panoramas/${this.post.preview}?nocache=${Date.now()}"/>
          <image>
            <sphere url="uploads/panoramas/${this.post.panorama}"/>
          </image>
        </krpano>
      `

      const krpCall = `loadxml(${krpScene}, null, MERGE, blend(1, linear));`

      this.pano.call(krpCall)
    },
    toggleGyro() {
      this.pano.call('switch(plugin[gyro].enabled)')
    },
    enterVr() {
      this.pano.call('webvr.toggleVR()')
    },
    rvonentervr() {
      this.pano.call('set(events[vr_events].onviewchange, followMenuAction()); set(hotspot[followMenuPrev].visible, true); set(hotspot[followMenuNext].visible, true);')
    },
    rvonexitvr() {
      this.pano.call('set(events[vr_events].onviewchange, null); set(hotspot[followMenuPrev].visible, false); set(hotspot[followMenuNext].visible, false)')
    },
    rvvrnext() {
    },
    rvvrprevious() {
    },
    handleNavigation(direction) {
      if (direction === 'next') {
        this.$router.push(this.pager.next.slug)
      } else {
        this.$router.push(this.pager.prev.slug)
      }
    },
    getStartPosition() {
      this.startPosition.h = this.pano.get('view.hlookat')
      this.startPosition.v = this.pano.get('view.vlookat')
    }
  }
}
</script>
